import "./Shop.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import ShopTitle from "./sections/ShopTitle";
import ShopContent from "./sections/ShopContent";
import SiteFooter from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <MainNavigationHeader />
      <ShopTitle />
      <ShopContent />
      <SiteFooter />
    </div>;
}